import ADND from './ADND'

export { ADND }

if ('undefined' !== typeof window && !window['$ADND']) {
  window['$ADND'] = ADND
}
